import { SofturaTable } from "client/CommonComponents";

 const ListAssignment = (props:any) => {
        const { approvalAssignement, approvalListAssignmentColumns, showGrid } = props;
        return (
            <div className={`pe-0 ${approvalAssignement?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                {showGrid && <SofturaTable
                    data={approvalAssignement ?? []}
                    columns={approvalListAssignmentColumns}
                    sort={false}
                    pagination={false}
                    globalSearch={false}
                    fixedHeader={true}
                    className="approvalHierarchy-grid"
                 data-attribute="ListAssignment_Default_Grid" />}
            </div> 
        );
    }

export default ListAssignment;